import { CaseInsensitiveMap } from "../../../../Global/Base/DataTypes/CaseInsensitiveMap";
import { IAttributeDescription } from "./IAttributeDescription";
/**
 * Interface popisujici strukturu třídy
 */
export interface IClassDescriptionCache {
    ChildClasses: Array<string>;
    ClassName: string;
    EncryptionAllowed: boolean;
    IsPersistent: boolean;
    PasswordMasterLink: string | null;
    RelatedClass: Array<string>;
    SigningAllowed: boolean;
    SupportsContext: boolean;
    VersioningAllowed: boolean;
    Attributes?: CaseInsensitiveMap<IAttributeDescription>;
}

/**
 * Interface popisujici strukturu třídy pro uložení do indexeddb
 */
export interface IClassDescriptionDbCache {
    className: string;
    serializedObject: string;
}
